export var textAlignmentAttributesList = {
  textAlign: true
};
export var textAlignmentAttributes = function textAlignmentAttributes(_ref) {
  var textAlign = _ref.textAlign;
  return textAlign ? "text-align: ".concat(textAlign, ";") : '';
};